var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 44,
    viewBox: "0 0 57 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9711 8.91716C50.8823 6.02752 51.8577 14.3283 49.7871 17.7241C47.7994 21.0003 41.4679 20.7426 38.9004 21.3132C36.342 21.8745 38.017 25.2059 38.017 25.2059L53.7075 20.1536L55.548 9.64418L49.9252 7.14105C49.9252 7.14105 47.7534 7.59198 46.9711 8.91716Z",
    fill: "url(#paint0_linear_2251_72629)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0783 8.91716C6.16716 6.02752 5.19167 14.3283 7.25306 17.7241C9.24084 21.0003 15.5723 20.7426 18.1398 21.3132C20.6981 21.8745 19.0233 25.2059 19.0233 25.2059L3.33272 20.1536L1.49219 9.64418L7.11503 7.14105C7.11503 7.14105 9.28685 7.59198 10.0691 8.91716H10.0783Z",
    fill: "url(#paint1_linear_2251_72629)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6114 8.50318C43.6114 8.50318 46.4367 6.20251 53.1086 6.36815C59.7713 6.5338 56.4124 17.7519 53.7804 21.4329C51.2497 24.9667 42.4243 23.4115 40.7954 24.3318C39.1757 25.2428 40.547 27.3686 39.8844 27.7367C39.2218 28.1048 37.1604 25.933 37.6481 24.0741C38.1543 22.1783 47.449 21.1016 50.7619 18.0739C54.1945 14.9358 53.1086 8.74244 50.0809 8.33752C46.5563 7.86819 46.1514 9.70873 45.9305 11.7977C45.7097 13.8407 42.3507 14.3653 42.3507 14.3653L43.6206 8.49398L43.6114 8.50318Z",
    fill: "url(#paint2_linear_2251_72629)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4583 27.7643C17.3478 27.7827 17.265 27.7827 17.2374 27.7827C17.2374 27.7827 17.1546 27.7643 17.1178 27.7459C16.446 27.3686 17.8264 25.2519 16.2067 24.3409C14.5779 23.4206 5.75249 24.9759 3.22175 21.442C0.580589 17.761 -2.76917 6.54293 3.89356 6.37728C10.5655 6.21163 13.3999 8.50309 13.3999 8.50309L14.6699 14.3836C14.6699 14.3836 11.3017 13.8591 11.09 11.8161C10.8692 9.72705 10.4643 7.88651 6.93964 8.35585C3.90276 8.76076 2.81685 14.945 6.25865 18.0831C9.57161 21.1107 18.8663 22.1874 19.3724 24.0832C19.3909 24.166 19.4093 24.2488 19.4277 24.3317C19.6485 25.8685 18.2865 27.5342 17.4859 27.7643H17.4583Z",
    fill: "url(#paint3_linear_2251_72629)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0142 24.9759C39.186 23.6968 45.2598 20.8992 48.7016 20.4022C52.1618 19.9053 53.1464 21.4329 53.1188 21.801C53.0912 22.1691 51.9041 23.4483 47.6984 23.8256C43.5112 24.2029 41.3394 23.5863 40.0142 24.9759Z",
    fill: "#FF4D74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70034 23.4299C2.41189 21.525 10.9151 21.0832 14.5134 22.0495C18.0656 23.0066 17.7712 25.1416 17.357 25.206C16.9429 25.2612 17.1822 24.2766 15.6729 24.1661C14.1545 24.0465 8.2556 23.9453 6.70955 23.4391L6.70034 23.4299Z",
    fill: "#FF4D74"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57422 7.14126C4.56508 4.56452 12.8659 5.60442 12.8659 5.60442L13.3812 8.50325C13.3812 8.50325 4.9608 5.03385 1.57422 7.14126Z",
    fill: "url(#paint4_linear_2251_72629)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2043 4.81288C45.2043 4.81288 53.1277 4.546 54.9038 6.80985C54.9038 6.80985 51.5725 5.12577 44.1367 8.16265L45.2043 4.82207V4.81288Z",
    fill: "url(#paint5_linear_2251_72629)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2034 5.328C45.2034 5.328 43.5009 12.5337 41.7708 17.6228C41.7524 17.678 41.7248 17.7424 41.7064 17.816C41.688 17.862 41.6696 17.8988 41.6604 17.9541C41.0714 19.6566 40.4824 21.0922 39.9671 21.8928C37.9609 24.9849 30.4884 28.2426 29.5681 33.9759C29.338 35.3839 29.6325 36.4606 30.2031 37.2889C31.7951 39.6263 35.5498 40.0405 36.1572 40.4546C36.1756 40.473 36.194 40.4822 36.2124 40.5006C36.9946 41.1172 37.7309 42.9853 37.7309 42.9853C37.7309 42.9853 33.6264 43.6111 28.4361 43.6111C23.2458 43.6111 19.1967 42.9853 19.1967 42.9853C19.1967 42.9853 19.9697 41.0251 20.7703 40.4546C21.3777 40.0312 25.3532 39.6079 26.9453 37.1784C27.4883 36.3594 27.7552 35.3195 27.5435 33.9667C26.6324 28.2334 18.9574 24.9665 16.9512 21.8836C15.7825 20.0891 14.6506 15.2209 13.8683 11.2729C13.2518 8.16242 12.8652 5.62248 12.8652 5.62248L28.5558 8.12561L45.1942 5.328H45.2034Z",
    fill: "url(#paint6_linear_2251_72629)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2716 4.15028C16.9067 0.119509 35.266 -2.32841 43.8521 3.29442C53.5609 9.64426 7.6396 10.3989 13.2716 4.15028Z",
    fill: "url(#paint7_linear_2251_72629)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5956 4.71169C20.8166 7.5001 37.6851 7.50009 41.0164 4.67487C43.2803 2.76072 36.1022 1.11345 28.9701 1.18707C22.1325 1.25149 15.5711 2.95398 17.5956 4.71169Z",
    fill: "url(#paint8_linear_2251_72629)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6611 17.9449C41.0722 19.6474 40.4832 21.083 39.9679 21.8836C37.9617 24.9757 30.4892 28.2335 29.5689 33.9668C29.3388 35.3748 29.6333 36.4515 30.2039 37.2797C28.529 39.0374 27.6823 38.5313 26.9461 37.1693C27.489 36.3502 27.7559 35.3103 27.5443 33.9576C26.6332 28.2243 18.9582 24.9573 16.952 21.8745C15.7833 20.0799 14.6514 15.2117 13.8691 11.2638L13.9427 11.0889C13.9427 11.0889 15.2679 22.5646 24.2957 25.2058C33.2223 27.8194 40.2439 21.81 41.6519 17.9357L41.6611 17.9449Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7227 23.798C20.0908 22.9974 24.1859 26.3011 27.7658 27.3594C31.3456 28.4178 28.456 30.8565 27.1308 30.4792C25.8056 30.1018 20.4773 24.5894 19.7319 23.798H19.7227Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7314 42.9764C37.7314 42.9764 33.627 43.6022 28.4367 43.6022C23.2464 43.6022 19.1973 42.9764 19.1973 42.9764C19.1973 42.9764 19.9703 41.0162 20.7709 40.4457C20.366 42.185 33.8847 40.8506 36.2222 40.4917C37.0044 41.1083 37.7406 42.9764 37.7406 42.9764H37.7314Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.388 43.5743C28.0413 43.1602 27.7101 41.927 29.0352 41.2828C29.8359 40.8963 31.5199 40.97 32.928 40.8687C36.6642 40.6019 37.2348 42.7645 37.152 42.9209C37.0692 43.0774 32.3482 43.5559 30.388 43.5835V43.5743Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2505 41.3105C24.0113 41.3105 23.8088 43.0498 24.0757 43.2615C24.3426 43.4731 26.8181 43.5468 27.2322 43.5744C27.6463 43.602 28.0881 41.7154 28.4654 41.4486C28.8427 41.1817 24.2505 41.3105 24.2505 41.3105Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5499 41.1633C22.1603 41.1081 24.2677 39.2308 27.3322 39.2308C30.3966 39.2308 31.6206 40.1326 31.7034 40.4363C31.777 40.74 27.2033 41.3106 23.5591 41.1541L23.5499 41.1633Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4522 7.14117C14.532 6.80987 15.0749 22.7397 24.296 25.206C33.517 27.6723 40.9988 12.9757 41.6522 9.98479C42.3056 6.99392 31.1427 9.68109 23.937 8.53996C16.7314 7.40804 15.443 7.13196 15.443 7.13196L15.4522 7.14117Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.311 1.8587C29.6973 2.33724 30.59 5.82506 31.4091 6.47845C32.2281 7.13183 39.6362 5.6594 40.7313 4.16857C41.8264 2.67774 35.311 1.8587 35.311 1.8587Z",
    fill: "#FF450C"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3126 1.8587C33.0488 2.30963 35.7636 4.30662 36.8771 4.2514C37.9906 4.18698 39.1777 2.63173 38.3403 2.43848C37.5028 2.24522 35.3126 1.8679 35.3126 1.8679V1.8587Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1557 6.80064C49.7416 7.20556 52.6221 8.43872 53.3767 12.3498C54.1313 16.261 56.8 12.8652 56.6712 9.98477C56.5331 7.10434 53.073 6.19327 50.1557 6.80064Z",
    fill: "#FF4D74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.598716 12.4879C0.755161 15.0555 2.6049 16.2518 2.96381 16.1782C3.32271 16.1046 2.65092 9.76393 7.0774 7.61971C8.96395 6.70865 1.92391 6.96632 1.27052 7.61971C0.617132 8.2731 0.451473 9.99401 0.598716 12.4879Z",
    fill: "#FF4D74"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2321 9.11049C16.6585 9.86511 18.4346 12.1474 19.1892 12.0001C19.9438 11.8529 19.8058 8.35587 18.2321 9.11049Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8906 6.95709C14.8906 6.95709 29.8633 9.10132 39.9403 7.56447C39.9403 7.56447 25.8418 9.99397 14.8906 6.95709Z",
    fill: "#FFE861"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5494 13.9696C41.5218 14.1168 41.4666 14.2732 41.4021 14.4297C40.7856 15.7641 38.6413 17.2549 37.4634 16.6291C37.0585 16.4175 36.8376 16.0954 36.7548 15.6996C36.4603 14.3284 37.7855 12.1014 38.6045 10.7946C39.6628 9.10135 41.807 12.5431 41.5494 13.9696Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0288 18.0833C35.9736 18.4882 35.854 18.9851 35.6791 19.5557C35.2834 20.8349 34.0134 19.9054 33.6637 18.8931C33.5993 18.7183 33.5625 18.5526 33.5625 18.387C33.5625 17.255 34.7036 16.2611 35.6791 16.7673C36.0104 16.9421 36.1116 17.4023 36.0288 18.0833Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5494 13.9696C41.5218 14.1168 41.4666 14.2732 41.4021 14.4297L41.3101 14.4481C41.3101 14.4481 41.393 14.0432 41.0156 12.8928C40.6383 11.7425 39.6444 10.4173 38.5493 11.3928C37.4726 12.3683 36.7824 15.5984 36.7548 15.6996C36.4603 14.3284 37.7855 12.1014 38.6045 10.7946C39.6628 9.10135 41.807 12.5431 41.5494 13.9696Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0288 18.0833C36.0288 18.0833 35.2282 16.6385 34.446 16.9606C33.6637 17.2919 33.6637 18.8931 33.6637 18.8931C33.5993 18.7183 33.5625 18.5526 33.5625 18.387C33.5625 17.255 34.7036 16.2611 35.6791 16.7673C36.0104 16.9421 36.1116 17.4023 36.0288 18.0833Z",
    fill: "#E56D8D"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8203 14.2732C42.8203 14.2732 44.6516 13.3713 45.5811 11.8345C46.5106 10.2976 44.9461 6.3681 44.9461 6.3681L42.8203 14.2824V14.2732Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0511 6.62597C13.0511 6.62597 12.7934 7.98796 12.4805 8.16282C12.1676 8.33767 10.9529 10.9236 11.5602 12.4052C12.1676 13.8869 14.6616 14.3746 14.6616 14.3746C14.6616 14.3746 13.4192 9.88371 13.0511 6.61676V6.62597Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13281 12.4049C4.39969 15.0553 5.22792 15.451 5.78928 15.2486C6.35064 15.0553 5.51319 9.47849 8.2832 8.29135C8.2832 8.29135 4.25245 8.01527 4.13281 12.4049Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5195 8.46613C49.5932 8.79743 51.7098 11.5398 51.7006 14.273C51.6822 17.0154 53.4951 11.4846 52.0226 9.71768C50.5502 7.95077 49.5287 8.46613 49.5287 8.46613H49.5195Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98295 18.4051C4.63016 18.129 6.82959 21.4512 9.51677 21.5616C12.1947 21.672 13.0322 21.5616 13.0322 21.5616C13.0322 21.5616 6.77438 18.5615 5.98295 18.4051Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8764 20.6137C45.8764 20.6137 50.5697 20.5585 51.6649 19.9971C52.76 19.445 52.8796 17.2087 52.5943 17.0799C52.3183 16.9418 51.2139 18.2118 49.0881 19.2425C46.9623 20.2732 45.8672 20.6137 45.8672 20.6137H45.8764Z",
    fill: "#FF450C"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2836 7.141C46.5474 7.32506 46.7498 5.86183 48.9216 5.63177C50.707 5.44771 51.3972 6.38638 51.3972 6.38638C51.3972 6.38638 50.4769 6.34957 47.2836 7.141Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94068 6.67188C6.01121 6.07371 12.8672 6.29458 10.8242 7.61056C10.8242 7.61056 9.0665 6.95716 6.94068 6.67188Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.251 41.3107C23.0454 41.1911 25.1805 39.8383 26.6805 40.4457C28.1897 41.0531 26.9934 41.5776 24.251 41.3107Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4773 19.9972C47.3117 20.2273 49.1522 20.1629 49.5939 19.3254C50.0356 18.488 47.8178 19.5095 47.4773 19.9972Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5589 20.7702C11.6141 21.1015 8.92695 20.5677 9.02818 20.0064C9.12941 19.445 11.4945 20.3469 11.5589 20.7702Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6483 24.0835C39.4244 22.5742 39.1483 27.5713 39.1483 27.5713C39.1483 27.5713 37.0777 25.7952 37.6483 24.0835Z",
    fill: "#E52F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4596 27.7643C17.3492 27.7827 17.2663 27.7827 17.2387 27.7827C17.1375 27.2214 18.2694 23.7796 19.4106 24.3317C19.6314 25.8686 18.2694 27.5342 17.4688 27.7643H17.4596Z",
    fill: "#E52F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2285 4.10409C17.3574 3.14701 22.2624 1.30648 25.2441 1.85864C28.2257 2.4108 31.0233 5.97223 30.8024 6.37715C30.5816 6.78206 18.747 7.06735 17.2285 4.10409Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7051 28.7399C30.5824 28.8043 29.1652 27.5067 30.0394 26.7429C31.5027 25.4729 36.4169 24.249 38.1286 22.6385L40.871 20.0618C40.871 20.0618 40.236 21.9483 37.9905 23.8717C35.7451 25.7858 32.2665 28.7215 31.7051 28.7491V28.7399Z",
    fill: "#DE5155"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8273 17.1725C35.9653 21.1481 32.8916 24.4978 28.9621 24.4978C25.0325 24.4978 21.9496 21.1481 22.0969 17.1725C22.2349 13.3534 25.3086 10.3625 28.9621 10.3625C32.6155 10.3625 35.6984 13.3534 35.8273 17.1725Z",
    fill: "url(#paint9_linear_2251_72629)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6764 19.675C23.3114 17.135 34.962 15.3773 35.5694 16.0307C36.186 16.6933 34.8424 23.8162 29.1735 23.8898C23.5047 23.9542 22.5016 20.3744 22.6764 19.6842V19.675Z",
    fill: "white"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4785 14.7148C26.4785 14.7148 27.3068 14.7608 27.951 12.9295C27.951 12.9295 29.1841 12.2669 30.4449 12.5429L30.6841 22.1505H27.7485L27.5368 16.5921L26.4785 16.4725V14.7148Z",
    fill: "url(#paint10_linear_2251_72629)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4785 14.7149L26.5614 14.356C26.5614 14.356 27.5737 13.9235 27.7853 12.6811C27.7853 12.6811 29.4418 11.9265 30.4449 12.5431C30.4449 12.5431 29.1749 12.3038 28.0522 12.9296C28.0522 12.9296 27.5552 14.5953 26.4785 14.7149Z",
    fill: "url(#paint11_linear_2251_72629)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0879 17.1721C22.0879 17.1721 23.6247 11.1996 29.1739 11.1996C34.4286 11.1996 35.6986 15.8285 35.6986 15.8285C35.6986 15.8285 34.7691 10.2057 28.7874 10.3622C22.7965 10.5186 22.0879 16.5279 22.0879 17.1721Z",
    fill: "#BE2F55"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0918 21.1106C23.0918 21.1106 25.1072 24.6812 29.3957 24.488C33.6841 24.2947 35.3405 20.0339 35.3405 20.0339C35.3405 20.0339 33.3343 25.1506 29.1747 25.1598C25.0151 25.169 23.0918 21.1106 23.0918 21.1106Z",
    fill: "url(#paint12_linear_2251_72629)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2251_72629",
    x1: 37.474,
    y1: 16.1781,
    x2: 55.5388,
    y2: 16.1781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2251_72629",
    x1: 19.5662,
    y1: -143.442,
    x2: 1.50139,
    y2: -143.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2251_72629",
    x1: 47.2833,
    y1: 27.792,
    x2: 47.2833,
    y2: 6.36815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2251_72629",
    x1: 9.70964,
    y1: 27.7827,
    x2: 9.70964,
    y2: 6.36808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2251_72629",
    x1: 1.57422,
    y1: 6.95721,
    x2: 13.3904,
    y2: 6.95721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2251_72629",
    x1: 44.1367,
    y1: 6.48776,
    x2: 54.9038,
    y2: 6.48776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2251_72629",
    x1: 12.8744,
    y1: 24.4695,
    x2: 45.2034,
    y2: 24.4695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2251_72629",
    x1: 12.7931,
    y1: 4.2331,
    x2: 45.2049,
    y2: 4.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2251_72629",
    x1: 19.1499,
    y1: 4.30956,
    x2: 43.4373,
    y2: 3.52084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2251_72629",
    x1: 28.9621,
    y1: 25.0518,
    x2: 28.9621,
    y2: 10.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EF6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2251_72629",
    x1: 28.5767,
    y1: 22.1413,
    x2: 28.5767,
    y2: 12.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2251_72629",
    x1: 26.4785,
    y1: 13.5094,
    x2: 30.4449,
    y2: 13.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2251_72629",
    x1: 23.0918,
    y1: 22.6014,
    x2: 35.3497,
    y2: 22.6014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardIcon);
export default __webpack_public_path__ + "static/media/awardIcon.8fe722cdefcb01ed14e867238c2b5049.svg";
export { ForwardRef as ReactComponent };